module.exports = __webpack_public_path__ + "static/media/find-results.7383cb9d.jpg";